import Layout from "@/components/layout";
import InvoicesController from "@/modules/invoices/InvoicesController";
import AccessRestricted from "@/components/AccessRestricted";
import { useHasPermission } from "@/store/authStore";
import { Permission } from "@forgepoint/shared";

export default function Invoices() {
  const canViewInvoices = useHasPermission(Permission.INVOICES_VIEW);

  if (!canViewInvoices) {
    return (
      <AccessRestricted
        breadcrumbs={[
          { label: "Records" },
          { label: "Invoices", current: true },
        ]}
      />
    );
  }

  return (
    <Layout breadcrumbs={[{ label: "Invoices", current: true }]}>
      <InvoicesController />
    </Layout>
  );
}
